import { ColumnType, DataColumn } from "../useTable/types"

type Accessor<T> = (rowData: T) => string | number | null | undefined
type AccessorColumn<T> = Omit<DataColumn<T>, "type" | "renderCell">
export type AccessorColumnHelper<T> = (
  accessorFn: Accessor<T>,
  col: AccessorColumn<T>
) => DataColumn<T>

export function accessor<T>(
  accessorFn: Accessor<T>,
  col: AccessorColumn<T>
): DataColumn<T> {
  return {
    type: ColumnType.Data,
    renderCell: accessorFn,
    ...col,
  }
}
